import { render, staticRenderFns } from "./ServiceStatus.vue?vue&type=template&id=98731e8a&"
import script from "./ServiceStatus.vue?vue&type=script&lang=js&"
export * from "./ServiceStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98731e8a')) {
      api.createRecord('98731e8a', component.options)
    } else {
      api.reload('98731e8a', component.options)
    }
    module.hot.accept("./ServiceStatus.vue?vue&type=template&id=98731e8a&", function () {
      api.rerender('98731e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/VPS/ServiceStatus.vue"
export default component.exports